import { motion } from "framer-motion";
// import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
// import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

// Temporarily commented out – FAQ content coming soon
// const faqs = [
//   {
//     q: "What are your hours of operation?",
//     a: "Hours vary by location. Many of our clubs offer 24/7 access. Check your location's page for specific hours and any special schedules for holidays.",
//   },
//   {
//     q: "How do I cancel my membership?",
//     a: "Submit a cancellation request through our website using the Cancellation Request form, or contact your home club directly. Your membership agreement may require advance notice. Someone from our team will reach out to assist you through the process.",
//   },
//   {
//     q: "Do you offer guest passes or trial visits?",
//     a: "Policies vary by location. Contact your nearest club or visit the location page for guest pass and trial information.",
//   },
//   {
//     q: "What is Jersey Girls Fitness?",
//     a: "Jersey Girls is our women-only fitness experience, available at select locations. It includes dedicated workout areas, group strength training sessions led by certified personal trainers, and childcare at some clubs. See our Jersey Girls page for details.",
//   },
//   {
//     q: "How do I update my contact information or billing?",
//     a: "Visit your home club in person with a valid ID, or contact the club by phone or email. For billing or payment issues, the front desk at your location can assist you.",
//   },
//   {
//     q: "Who do I contact for support?",
//     a: "For general questions, use our Contact Us form or call (856) 382-0555. For feedback about your experience, use our Feedback form. For cancellation requests, use the Cancellation Request page.",
//   },
// ];

export default function FAQPage() {
  return (
    <div className="min-h-screen pt-20" data-testid="faq-page">
      <SEO
        title="Frequently Asked Questions"
        description="FAQs coming soon. Contact Jersey Girls for questions about memberships, locations, and support."
        url="/support"
      />
      <section className="py-12 md:py-20 px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-brand-pink/20 flex items-center justify-center">
              <HelpCircle className="w-8 h-8 text-brand-pink" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-black text-gray-900 mb-4 text-center" data-testid="faq-heading">
              FREQUENTLY ASKED QUESTIONS
            </h1>
            <p className="text-2xl md:text-3xl font-heading font-bold text-brand-pink">
              Coming Soon!
            </p>
            {/* <Accordion type="single" collapsible className="space-y-0">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-gray-200">
                  <AccordionTrigger className="text-gray-900 hover:text-brand-pink py-5 text-left">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-700">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            <p className="text-gray-600 text-center mt-10">
              Still have questions? <Link to="/contact" className="text-brand-pink hover:underline font-medium">Contact us</Link> and we’ll get back to you shortly.
            </p> */}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
